import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Voter } from 'src/app/models/Voter';

@Component({
  selector: 'app-suspended-table',
  templateUrl: 'suspended-table.component.html',
  styleUrls: ['./suspended-table.component.less', '../../shared/common.less'],
})

export class SuspendedTableComponent implements OnInit, OnDestroy {
  @Input() suspended: Array<any> = [];
  @Input() selectedVoters: any;
  @Input() filteredVoters: Array<Voter> = [];
  @Input() editionMode: boolean = true;
  @Output() selectedVotersChange = new EventEmitter<any>();
  @Output() voterEdited = new EventEmitter<void>();
  editingIndex: number = -1;
  editingVoter: Partial<Voter> = {};
  private intervalId: any;

  constructor() { }

  selectionChangedEvent(newSelection: any) {
    this.selectedVoters = newSelection;
    this.selectedVotersChange.emit(newSelection);
  }

  editLastNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, lastName: value };
  }

  editFirstNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, firstName: value };
  }

  editCollegeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, college: value };
  }

  editEmailAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, email: value };
  }

  editPhoneAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, phone: value };
  }

  editValidationCodeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, validationCode: value };
  }

  resetVoters() {
    this.filteredVoters = [];
  }

  getRemainingTime(voter: any): string {
    const lockDate = new Date(voter.lockDate);
    const now = new Date();
    
    // Ajouter 1 minute à la date de blocage pour obtenir la date de déblocage
    const unlockDate = new Date(lockDate.getTime() + 60 * 1000); // +60 secondes
    
    // Calculer le temps restant en millisecondes
    const remainingMilliseconds = unlockDate.getTime() - now.getTime();
    
    // Si le temps est écoulé, retourner 00:00
    if (remainingMilliseconds <= 0) {
      return '00:00';
    }
    
    // Convertir en secondes totales
    const remainingSeconds = Math.floor(remainingMilliseconds / 1000);
    
    // Calculer les minutes et secondes
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  ngOnInit(): void {
    // Mettre à jour le décompte toutes les secondes
    this.intervalId = setInterval(() => {
      // Force Angular à détecter les changements
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
